angular.module('app')
	.directive('footer', function(){
		return {
			restrict: 'A',
			templateUrl: 'views/footer.html',
			link: function(scope) {
				scope.text = '© Lockeroom Enterprises, LLC';
			}
		};
	});
